export const colors = {
  red: "red",
  green: "green",
  blue: "blue",
  magenta: "magenta",
  brown: "brown",
  yellow: "yellow",
  orange: "orange",
  black: "black",
};

export const betTypeGroup = {
  BALLS_BET: "BALLS_BET",
  COLOR_BET: "COLOR_BET",
  SPECIAL_BET: "SPECIAL_BET",
};

// colors value as a numbers
export const colorsAsNumbers = {
  [colors.red]: 1,
  [colors.green]: 2,
  [colors.blue]: 3,
  [colors.magenta]: 4,
  [colors.brown]: 5,
  [colors.yellow]: 6,
  [colors.orange]: 7,
  [colors.black]: 8,
};

export const specifierValueForSpecialBets = {
  EVEN: 1,
  ODD: 2,
  UNDER: 1,
  OVER: 2,
  ["SYSTEM67"]: 7,
  ["SYSTEM68"]: 8,
  ["SYSTEM69"]: 9,
  ["SYSTEM610"]: 10,
  ["MOST_FREQUENT_COLOR1"]: 1,
  ["MOST_FREQUENT_COLOR2"]: 2,
  ["MOST_FREQUENT_COLOR4"]: 4,
  ["FIRST_BALL_COLOR1"]: 1,
  ["FIRST_BALL_COLOR2"]: 2,
  ["FIRST_BALL_COLOR4"]: 4,
  ["LAST_BALL_COLOR1"]: 1,
  ["LAST_BALL_COLOR2"]: 2,
  ["LAST_BALL_COLOR4"]: 4,
};

// bet type value for each bet wich setted up in Winning plan(data from the server)
export const betTypeForBetName = {
  PRE_BALL_NUMBER: 6,
  FIRST_NUMBER_EVEN_ODD: 2,
  FIRST_NUMBER_UNDER_OVER: 3,
  PRE_NUMBER_EVEN_ODD: 4,
  PRE_NUMBER_SUM_UNDER_OVER: 5,
  RANDOM: 1,
  ALL_COLORS: 1,
  CUSTOM: 9, //SYSTEM bets
  MOST_FREQUENT_COLOR: 10,
  FIRST_BALL_COLOR: 7,
  LAST_BALL_COLOR: 8,
  MORE_EVEN_OR_ODD: 11,
};

// type of bets
export const betTypesForBetBetslip = {
  CUSTOM: {
    ["SYSTEM67"]: "SYSTEM6/7",
    ["SYSTEM68"]: "SYSTEM6/8",
    ["SYSTEM69"]: "SYSTEM6/9",
    ["SYSTEM610"]: "SYSTEM6/10",
  },
  RANDOM: "STANDARD",
  PRE_BALL_NUMBER: "PreBallsNumber",

  FIRST_NUMBER_EVEN_ODD: "FirstBallEven/Odd",
  FIRST_NUMBER_UNDER_OVER: "FirstBall",
  PRE_NUMBER_EVEN_ODD: "PreBallsEven/Odd",
  PRE_NUMBER_SUM_UNDER_OVER: "PreBallsSum",

  MOST_FREQUENT_COLOR: "MostFrequentColor",
  FIRST_BALL_COLOR: "FirstBallColor",
  LAST_BALL_COLOR: "LastBallColor",
  MORE_EVEN_OR_ODD: "MoreEvenOrOdd",
};

// type of bets
export const betTypesForTipData = {
  CUSTOM: {
    ["SYSTEM67"]: "SYSTEM6/7",
    ["SYSTEM68"]: "SYSTEM6/8",
    ["SYSTEM69"]: "SYSTEM6/9",
    ["SYSTEM610"]: "SYSTEM6/10",
  },
  RANDOM: "STANDARD",
  PRE_BALL_NUMBER: "PreBallsNumber",

  FIRST_NUMBER_EVEN_ODD: "FirstBallEven/Odd",
  FIRST_NUMBER_UNDER_OVER: "FirstBall",
  PRE_NUMBER_EVEN_ODD: "PreBallsEven/Odd",
  PRE_NUMBER_SUM_UNDER_OVER: "PreBallsSum",
  MORE_EVEN_OR_ODD: "MoreEvenOrOdd",

  MOST_FREQUENT_COLOR: "Most Frequent Color",
  FIRST_BALL_COLOR: "FirstBallColor",
  LAST_BALL_COLOR: "LastBallColor",
  ALL_COLOR_RED: "allColorred",
  ALL_COLOR_GREEN: "allColorgreen",
  ALL_COLOR_BLUE: "allColorblue",
  ALL_COLOR_MAGENTA: "allColormagenta",
  ALL_COLOR_BROWN: "allColorbrown",
  ALL_COLOR_YELLOW: "allColoryellow",
  ALL_COLOR_ORANGE: "allColororange",
  ALL_COLOR_BLACK: "allColorblack",
};

// type of bets
export const betTypesForBetsContainer = {
  CUSTOM: "CUSTOM",
  RANDOM: "RANDOM",
  ALL_COLORS: "ALL_COLORS",
  PRE_BALL_NUMBER: "PRE_BALL_NUMBER",
  FIRST_NUMBER_EVEN_ODD: "FIRST_NUMBER_EVEN_ODD",
  FIRST_NUMBER_UNDER_OVER: "FIRST_NUMBER_UNDER_OVER",
  PRE_NUMBER_EVEN_ODD: "PRE_NUMBER_EVEN_ODD",
  PRE_NUMBER_SUM_UNDER_OVER: "PRE_NUMBER_SUM_UNDER_OVER",
  MOST_FREQUENT_COLOR: "MOST_FREQUENT_COLOR",
  FIRST_BALL_COLOR: "FIRST_BALL_COLOR",
  LAST_BALL_COLOR: "LAST_BALL_COLOR",
  MORE_EVEN_OR_ODD: "MORE_EVEN_OR_ODD",
};

export const MAX_CHECKED_BALLS = 10;
export const MIN_CHECKED_BALLS = 6;
export const MAX_BALL_NUMBER = 48;
export const MAX_CHECKED_BALL_COLOR = 4;

export const ballsColorColumns = {
  [colors.red]: {
    1: false,
    9: false,
    17: false,
    25: false,
    33: false,
    41: false,
  },
  [colors.green]: {
    2: false,
    10: false,
    18: false,
    26: false,
    34: false,
    42: false,
  },
  [colors.blue]: {
    3: false,
    11: false,
    19: false,
    27: false,
    35: false,
    43: false,
  },
  [colors.magenta]: {
    4: false,
    12: false,
    20: false,
    28: false,
    36: false,
    44: false,
  },
  [colors.brown]: {
    5: false,
    13: false,
    21: false,
    29: false,
    37: false,
    45: false,
  },
  [colors.yellow]: {
    6: false,
    14: false,
    22: false,
    30: false,
    38: false,
    46: false,
  },
  [colors.orange]: {
    7: false,
    15: false,
    23: false,
    31: false,
    39: false,
    47: false,
  },
  [colors.black]: {
    8: false,
    16: false,
    24: false,
    32: false,
    40: false,
    48: false,
  },
};

// delay before user's logout in terminal version
export const TICKET_COUNT_FOR_LOADING = 20;

// transaction type of credits history
export const transactionTypes = {
  WITHDRAW_VOUCHER: "WITHDRAW_VOUCHER",
  [`ADD CREDITS`]: `ADD CREDITS`,
  [`SUB CREDITS`]: "SUB CREDITS",
  INITIAL_BALANCE: "INITIAL_BALANCE",
  DEPOSIT_VOUCHER: "DEPOSIT_VOUCHER",
};

// lifecycle statuses
export const lifecycleStates = {
  BET: "BET",
  BET_LOCKED: "BET_LOCKED",
  RACE: "RACE",
  DELAY: "DELAY",
  WINNING_PLAN: "WINNINGPLAN",
  DRAW: "DRAW",
};

// types of bet(values are equals data-type-bet attribute of odds cell)
export const betsTypeForBetRequest = {
  winBet: "WinBet (%win%)",
  inFirst3: "In First 3 (%win%)",
  quinella: "Quinella (%win%)",
  perfecta: "Perfecta (%win%)", // exacta
  trifecta: "Trifecta (%win%)",
  over: "Over (%win%)",
  under: "Under (%win%)",
  even: "Even (%win%)",
  odd: "Odd (%win%)",
};

// bets tip for show notification
export const betsTipForNotification = {
  EVEN: "Even",
  ODD: "Odd",
  LOW: "Under",
  HIGH: "Over",
  QUINELLA: "Quinella",
  TRIFECTA: "Trifecta",
  PERFECTA: "Exacta",
  FIRST: "Winner",
  PLACEBET: "In First 3",
};

// modes of stake in betslip component of basket
export const stakeModes = {
  STAKE_PER_BET_MODE: "stakePerBet",
  SPLIT_STAKE_MODE: "splitStake",
};

// alias for Stake bet in Betslip container
export const incrementsForStake = {
  1: "+1",
  5: "+5",
  10: "+10",
  25: "+25",
  50: "+50",
  [`Max`]: "Max",
};

export const withdrawsStates = {
  ACTIVE: "ACTIVE",
  CASHED_OUT: "CASHED_OUT",
  APPLIED: "APPLIED",
};

// pre-loader loading text
export const loadingText = {
  loading: "LOADING...",
};

// rotation warning text
export const rotationText = {
  rotationMessage: "Please rotate your device",
};

// info message types
export const toastMessageTypes = {
  WARN: "WARN",
  INFO: "INFO",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

// form field names
export const inputsNames = {
  LOGIN: "login",
  PINCODE: "pincode",
  EMAIL: "email",
  PINCODECONFIRM: "pincodeConfirm",
  USERNAME: "username",
  PASSWORD: "password",
  WITHDRAWMONEY: "withdrawMoneyAmount",
  VOUCHERCODE: "voucher_code",
  IDNUMBER: "idNumber",
  USERPASSWORD: "password",
  OLDPASSWORD: "oldPassword",
  PASSWORDCONFIRM: "passwordConfirm",
};

// ticket states
export const ticketStates = {
  NOVICE: "NOVICE",
  WINNING: "WINNING",
  LOSING: "LOSING",
};

// bet statuses
export const betStatuses = {
  NOVICE: "PENDING",
  WON: "WON",
  LOST: "LOST",
};

export const ticketStatesOptions = [
  { value: "NOVICE", label: "PENDING", isFixed: true },
  { value: "WINNING", label: "WINNING" },
  { value: "LOSING", label: "LOSING" },
];

export const statuses = {
  statusForRedirect: 401,
  statusOk: 200,
  statusOkNoContent: 204,
  clientError: 400,
  notFound: 404,
  internalError: 500,
};

export const EVEN_ODD = {
  "1": "EVEN",
  "2": "ODD",
};

export const UNDER_OVER = {
  "1": "UNDER",
  "2": "OVER",
};
